import {
  IStyles,
  InputFieldContainer,
  LinkButton,
  Loader,
  PrimaryButton,
  deserify,
  getLocalStorage,
  isValidEmail,
  pxToRem,
  pxTovW,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  HOME,
  OTP_SCREEN,
  SCREEN_RESOLVER,
  VERIFY_EMAIL,
} from '../../../../routeHandling/RoutesNomenclature';
import {
  setOtpInfo,
  setToastInfo,
  setUserInfo,
  setVerifyPath,
} from '../../reducer/auth.slice';

import { OTPEnum } from '@protos/user_management/ums.db_pb';
import { useGlobalContext } from '../../../../app/Context/GlobalContextProvider';
import { useAppSelector } from '../../../../reduxStore/reduxHooks';
import { aiLoginEvent } from '../../Login/login_logout.events';
const styles: IStyles = {
  root: {
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: { xs: 'start', md: 'center' },
    // backgroundColor: 'red',
    // mt: { xs: pxToRem(20), md: pxTovW(20) },
  },
  heading: {
    display: 'flex',
    flexDirection: 'column',
    gap: pxToRem(5),
    textAlign: { xs: 'left', md: 'center' },

    // backgroundColor: 'blue',
    // margin: 'auto',
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(20), md: pxTovW(61) },
  },
  inputContainer: {
    mt: { xs: pxToRem(50), md: pxTovW(60) },
  },
  skip: {
    width: { xs: pxToRem(75), md: pxTovW(140) },
    height: { xs: pxToRem(42), md: pxTovW(82) },
    // display: 'flex',
    position: 'relative',
    // left: '100%',
    '& > span': {
      fontSize: pxToRem(16),
      color: '#007CDC',
      // backgroundColor: 'blue',
      padding: '0px',
    },
  },

  secondaryButtonBox: {
    width: { xs: '100%', md: pxTovW(517) },
    margin: 'auto',
    mt: { xs: pxToRem(92), md: pxTovW(38) },
  },
};
export const VerifyEmail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [credentialError, setCredentialError] = useState<string | undefined>(
    undefined
  );
  const [loading, setLoading] = useState<'loading' | 'completed' | 'error'>(
    'completed'
  );

  const { user_validation_info, userInfo } = deserify(
    useAppSelector((state) => state.auth)
  );
  // For backclick redirection

  const { selectedFunction, setSelectedFunction } = useGlobalContext();
  const { UMSLoginAPIServiceV1ClientWithStatusCodeHandler } =
    useCommonServiceClientContext();

  const backClick = async () => {
    // dispatch(
    //   setToastInfo({
    //     label: 'user Id  activated Please Login',
    //     variant: 'success',
    //     open: true,
    //   })
    // );
    await aiLoginEvent({
      studentId: Number(userInfo?.studentProfileId.toString()),
      sessionId: getLocalStorage('activeSession') || 'verifyEmailBack',
      isOffline: false,
    });
    navigate(HOME);
  };
  useEffect(() => {
    setSelectedFunction(() => backClick);
  }, []);
  const handleCredentialChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!isValidEmail(event.target.value)) {
      setCredentialError('Enter valid Email id');
    } else {
      setCredentialError(undefined);
    }
    setEmailId(event.target.value);
  };
  const [emailId, setEmailId] = useState(
    userInfo?.email || user_validation_info?.email || ''
  );
  const nextClickHandler = async () => {
    if (!isValidEmail(emailId)) {
      setCredentialError('enter valid email id');
      return;
    }
    try {
      setLoading('loading');
      const [updateProfile, sendOtp] = await Promise.all([
        UMSLoginAPIServiceV1ClientWithStatusCodeHandler.updateStudentProfile({
          studentProfileId: user_validation_info?.profileId,
          email: emailId,
          emailVerify: 0,
        }),
        UMSLoginAPIServiceV1ClientWithStatusCodeHandler.getEmailOTP({
          email: emailId,
          userName: user_validation_info?.userName,
          otpType: OTPEnum.STUDENT_VERIFICATION,
        }),
      ]);

      if (updateProfile.status === 200 && sendOtp.status === 200) {
        setLoading('completed');
        // dispatch(
        //   setToastInfo({
        //     label: 'otp sent to your email id',
        //     variant: 'success',
        //     open: true,
        //   })
        // );
        dispatch(
          setOtpInfo({
            verification_code: sendOtp.verificationCode,
            otp_type: OTPEnum.STUDENT_VERIFICATION,
          })
        );
        dispatch(setUserInfo(updateProfile.data));
        dispatch(setVerifyPath(VERIFY_EMAIL));
        navigate(OTP_SCREEN);
      } else {
        dispatch(
          setToastInfo({
            label: sendOtp.message
              ? `${sendOtp.message.replace(/\[.*?\]/g, '')}}`
              : 'Something went wrong or the Email Id is invalid.',
            variant: 'error',
            open: true,
          })
        );
      }
    } catch (error: any) {
      setLoading('error');
      dispatch(
        setToastInfo({
          label: `${
            error.rawMessage
              ? error.rawMessage?.replace(/.*\]\s*/, '').trim()
              : error.message
              ? error.message.replace(/.*\]\s*/, '').trim()
              : 'Something Went Wrong or the Email Id is invalid.'
          }`,
          variant: 'error',
          open: true,
        })
      );
      console.log(error);
    }
  };
  return loading === 'loading' ? (
    <Loader />
  ) : (
    <Box sx={{ display: 'flex', height: '100%' }}>
      <Box
        sx={{
          ...styles.root,
          width: { xs: '100%', md: '50%' },
          display: 'flex',
        }}
      >
        <Box sx={styles.mainContainer}>
          <Box
            sx={{
              display: 'flex',
              // backgroundColor: 'red',
              alignItems: 'flex-end',
              justifyContent: { xs: 'space-between', md: 'center' },
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Box sx={styles.heading}>
              <Typography variant="h1" fontWeight="bold">
                Connect Your
              </Typography>
              <Typography variant="h1" color="primary" fontWeight="bold">
                Email ID
              </Typography>
            </Box>

            <Box
              sx={{
                position: { md: 'fixed' },
                right: { md: pxTovW(100) },
                // backgroundColor: 'blue',
              }}
            >
              <LinkButton
                rootStyle={{ ...styles.skip, justifySelf: 'right' }}
                onClick={async () => {
                  await aiLoginEvent({
                    studentId: Number(userInfo?.studentProfileId.toString()),
                    sessionId:
                      getLocalStorage('activeSession') || 'verifyEmailSkip',
                    isOffline: false,
                  });
                  const qrId = getLocalStorage('qrId');
                  if(qrId){
                    navigate(`${SCREEN_RESOLVER}?QRId=${qrId}`);
                  } else {
                    navigate(HOME);
                  }
                }}
              >
                Skip
              </LinkButton>
            </Box>
          </Box>
          <Box sx={{ mb: { xs: pxToRem(15), md: pxTovW(30) } }}>
            <InputFieldContainer
              helperTextvariant="error"
              topLabel="Enter Email ID"
              value={emailId}
              onChange={handleCredentialChange}
              helperText={credentialError}
              //   nonEditable={true}
              onEnter={nextClickHandler}
              type="email"
            />
          </Box>

          <Box sx={styles.secondaryButtonBox}>
            <PrimaryButton
              fullWidth
              onClick={nextClickHandler}
              disabled={credentialError !== undefined}
            >
              <Typography variant="h1" color="success.light">
                Next
              </Typography>
            </PrimaryButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
